import { AbortReasonProduct } from 'models/AbortCategory';
import { CustomerAppointmentType } from 'models/Appointment';

export function determineAbortReasonProduct(
  appointmentType: CustomerAppointmentType | undefined
) {
  switch (appointmentType) {
    case CustomerAppointmentType.EV:
    case CustomerAppointmentType.EV_ISOLATOR:
      return AbortReasonProduct.EV;
    case CustomerAppointmentType.ENERGY_EXPERTS:
      return AbortReasonProduct.Energy_Experts;
    default:
      return AbortReasonProduct.Smart;
  }
}
